module.exports = __webpack_public_path__ + "img/vr2_detail_1.7742dc22.jpg";